export default __webpack_public_path__ + "static/media/ogres-stacija.7a9a97af.jpg";